import React from "react";
import { Routes, Route } from "react-router-dom";

// Routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";

// AuthProvider
import { AuthProvider } from "./AuthProtected";

// Layouts
import Layout from "../Layouts";
import NonAuthLayout from "../Layouts/NonAuthLayout";
import Store from "../pages/store/store";

const isStorefrontDomain = () => {
  const hostname = window.location.hostname.toLowerCase().replace(/^www\./, "");
  return (
    hostname !== "app.therudrix.in" &&
    !hostname.startsWith("admin.") &&
    hostname !== "localhost" &&
    hostname !== "127.0.0.1"
  );
};

const Index = () => {
  const isStore = isStorefrontDomain();

  return (
    <AuthProvider>
      <Routes>
        {/* If accessing from storefront domain, root / opens the store directly */}
        {isStore && (
          <Route
            path="/"
            element={<NonAuthLayout><Store /></NonAuthLayout>}
          />
        )}

        {/* Public Routes */}
        {publicRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
          />
        ))}

        {/* Protected Routes */}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={<Layout>{route.component}</Layout>}
          />
        ))}
      </Routes>
    </AuthProvider>
  );
};

export default Index;
